(() => {
  const PREFIX = 'Google_Discount_';
  const PRODUCT_SELECTOR = '[data-lennies-google-product]';
  let cartRequest;
  let refreshTimer;

  function cart() {
    if (!cartRequest) cartRequest = fetch('/cart.js', {credentials:'same-origin', cache:'no-store'}).then(r => {
      if (!r.ok) throw new Error('Cart unavailable');
      return r.json();
    }).finally(() => { setTimeout(() => { cartRequest = null; }, 250); });
    return cartRequest;
  }

  function offerFromCart(data) {
    try { const stored=JSON.parse(atob(data.attributes?._gad || '')); return stored.P>=Date.now() && typeof stored.S==='object' ? stored.S : null; } catch { return null; }
  }
  async function offerFromLink() {
    try {
      const token=new URLSearchParams(location.search).get('pv2');if(!token)return null;
      const parts=token.split('.');if(parts.length!==3)return null;
      const decode=s=>Uint8Array.from(atob(s.replace(/-/g,'+').replace(/_/g,'/')),c=>c.charCodeAt(0));
      const key=await crypto.subtle.importKey('spki',decode('MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAERUlUpxshr67EO66ZTX0Fpog0LEHcnUnlSsIrOfroxTLu2XnigBK/lfYRxzQWq9K6nqsSjjYeea0T12r+y3nvqg=='),{name:'ECDSA',namedCurve:'P-256'},false,['verify']);
      if(!await crypto.subtle.verify({name:'ECDSA',hash:'SHA-256'},key,decode(parts[2]),new TextEncoder().encode(parts[0]+'.'+parts[1])))return null;
      const p=JSON.parse(new TextDecoder().decode(decode(parts[1])));if(!(p.exp*1000>Date.now()))return null;
      return {merchantId:p.m,offerId:p.o,price:p.p,currency:p.c};
    }catch{return null;}
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function fillNotice(root, heading, paragraphs, items=[]) {
    root.replaceChildren();
    const label = element('div','lennies-google-offer__label','Google Shopping price');
    root.append(label, element('strong','lennies-google-offer__heading',heading));
    paragraphs.forEach(text => root.append(element('p','lennies-google-offer__text',text)));
    if (items.length) {
      const list=element('ul','lennies-google-offer__list');
      items.forEach(text => list.append(element('li','',text)));
      root.append(list);
    }
    root.hidden=false;
  }

  async function productNotice() {
    const root=document.querySelector(PRODUCT_SELECTOR);if(!root)return;
    const variants=JSON.parse(root.dataset.variants || '[]');
    const selected=document.querySelector('product-info form[action*="/cart/add"] [name="id"]')?.value || root.dataset.variant;
    const variant=variants.find(v=>String(v.id)===String(selected));if(!variant)return;
    const normal=Number(variant.price)/100,currency=root.dataset.currency;
    const matches=o=>o && String(o.merchantId)==='473580270' && String(o.offerId).split('_').pop()===String(selected) && o.currency===currency && Number.isFinite(Number(o.price)) && Number(o.price)<normal;
    let offer=await offerFromLink();
    if(!matches(offer)){try{offer=offerFromCart(await cart());}catch{}}
    if(matches(offer)){
      const money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency}).format(n);
      fillNotice(root,'Google automated discount: one unit only',[
        `You arrived with a Google offer for this product. Additional units cost ${money(normal)} each.`,
        'Offers cannot be combined. If you enter another eligible discount code, checkout applies whichever offer saves you more.'
      ]);return;
    }
    root.hidden=true;
  }
  function googleItems(data) {
    return (data.items || []).filter(item => (item.discounts || []).some(discount => String(discount.title || '').startsWith(PREFIX)));
  }

  async function cartNotices() {
    let data;
    try { data=await cart(); } catch { return; }
    const items=googleItems(data);
    document.querySelectorAll('[data-lennies-google-cart-notice]').forEach(node => node.remove());
    if (!items.length) return;
    const descriptions=items.map(item => item.quantity > 1
      ? `${item.product_title}: 1 of ${item.quantity} receives the Google price; ${item.quantity-1} ${item.quantity-1===1?'unit is':'units are'} charged at the normal price.`
      : `${item.product_title}: Google price applied to 1 unit.`);
    const targets=[...document.querySelectorAll('.drawer__footer, #main-cart-footer .cart__footer, #main-cart-footer')]
      .filter((target,index,list)=>!list.some((other,i)=>i<index&&other.contains(target)));
    targets.forEach(target => {
      const root=element('div','lennies-google-offer lennies-google-offer--cart');
      root.dataset.lenniesGoogleCartNotice='';
      fillNotice(root,'Google automated discount: one unit only',[
        'Offers cannot be combined. Enter another eligible code and checkout applies whichever offer saves you more.'
      ],descriptions);
      target.prepend(root);
    });
  }

  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer=setTimeout(() => { cartRequest=null; cartNotices(); },300);
  }

  const style=element('style');
  style.textContent=`
    .lennies-google-offer{margin:1.2rem 0;padding:1.4rem 1.5rem;border:2px solid #102a56;border-radius:1.4rem;background:#fff3ad;color:#102a56;box-shadow:4px 5px 0 #102a56;line-height:1.45}
    .lennies-google-offer__label{display:inline-block;margin-bottom:.7rem;padding:.3rem .75rem;border-radius:999px;background:#ffd92f;font-size:1.15rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase}
    .lennies-google-offer__heading{display:block;font-size:1.65rem;line-height:1.2}
    .lennies-google-offer__text{margin:.65rem 0 0}
    .lennies-google-offer__list{margin:.75rem 0 0;padding-left:1.8rem}
    .lennies-google-offer--cart{margin:0 0 1.5rem;background:#d9f3ed}
  `;
  document.head.append(style);
  productNotice();
  if (location.pathname === '/cart') cartNotices();
  document.addEventListener('cart:refresh',scheduleCartRefresh);
  document.addEventListener('cart:updated',scheduleCartRefresh);
  if (typeof window.subscribe==='function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,scheduleCartRefresh);
  }
  document.addEventListener('click',event => {
    if (event.target.closest('.header__icon--cart, [data-cart-drawer-trigger]')) setTimeout(scheduleCartRefresh,0);
    if (event.target.closest('cart-remove-button, quantity-input button, [name="add"]')) setTimeout(scheduleCartRefresh,500);
  });
  document.addEventListener('submit',event => {
    if (event.target.matches('form[action*="/cart"]')) setTimeout(scheduleCartRefresh,500);
  });
})();
